/* eslint-disable global-require */
import React from 'react';
import { Card, Row, Col } from 'antd';
// import { ShareAltOutlined } from '@ant-design/icons';
import CustomCard from 'components/Containers/Card';
import Container from 'components/Containers/Container';
import started from './started.png';

// import faf_ne from './imgs/faf-national-edition.png';

// import faf_se from './imgs/faf-special-edition.png';

const { Meta } = Card;

const data = [
  {
    title: 'Grade 2 - Unit 4 -  Lesson 1',
    subTitle: 'Bài giảng điện tử',
    image: started,
    url: 'https://content.sachso.edu.vn/BaiGiangDienTu_heid/Grade02_Unit04_Lesson01/index.html',
  },
  {
    title: 'Grade 2 - Unit 4 -  Lesson 2',
    subTitle: 'Bài giảng điện tử',
    image: started,
    url: 'https://content.sachso.edu.vn/BaiGiangDienTu_heid/Grade02_Unit04_Lesson02/index.html',
  },
  {
    title: 'Grade 2 - Unit 4 -  Lesson 3',
    subTitle: 'Bài giảng điện tử',
    image: started,
    url: 'https://content.sachso.edu.vn/BaiGiangDienTu_heid/Grade02_Unit04_Lesson03/index.html',
  },
];

const renderCards = (item, index) => {
  return (
    <Col key={index} style={{ cursor: 'pointer' }} onClick={() => window.open(item.url, '_blank')}>
      <Card
        style={{ maxWidth: 300 }}
        cover={
          <img
            alt="example"
            src={item.image}
          // style={{ height: 214 }}
          />
        }
      // actions={[
      //   <ShareAltOutlined key="play" />,
      // ]}
      >
        <Meta
          // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title={item.title}
          description={item.subTitle}
        />
      </Card>
    </Col>
  );
};

const OnlineLetures = () => {
  return (
    <React.Fragment>
      <Row gutter={[16, 16]}>
        {
          data.map(renderCards)
        }
      </Row>
    </React.Fragment>
  );
};

export default OnlineLetures;
